export const properties = {
    apikey: "812bf1e0",
    host: "http://www.omdbapi.com/"
}